import * as Types from '../mutationTypes';
import HestiaApi  from '@/api/index.js';

// initial state
const state = {
  vendorLeads       : {
    results    : [],
    pagination : {
      perPage : 10,
      page    : 1,
      total   : 0
    }
  },
  currentVendorLead : {}
};

// getters
const getters = {
  vendorLeads       : state => state.vendorLeads,
  currentVendorLead : state => state.currentVendorLead
};

// actions
const actions = {
  setVendorLeads({ commit }, vendorLeads) {

    commit(Types.RECEIVE_VENDOR_LEADS, vendorLeads);
  },
  async selectVendorLead({ commit }, { tenantId, id }) {

    const response = await HestiaApi.Lead.vendorLead.get(tenantId, id).json();
    commit(Types.SELECT_VENDOR_LEAD, response);

    await getSteps(commit, tenantId, id);
  },
  async editVendorLead({ commit }, { tenantId, id, vendorLead }) {

    const response = await HestiaApi.Lead.vendorLead.update(tenantId, id, vendorLead).json();
    commit(Types.SELECT_VENDOR_LEAD, response);

    await getSteps(commit, tenantId, id);
  },
  async pauseVendorLead({ commit }, { tenantId, payload }) {

    await HestiaApi.Lead.pause.postPause(tenantId, payload.workflow, payload).json();

    await getSteps(commit, tenantId, payload.modelId);
  },
  async unpauseVendorLead({ commit }, { tenantId, id, payload, vendorLeadId }) {

    await HestiaApi.Lead.pause.patchPause(tenantId, id, payload).json();

    await getSteps(commit, tenantId, vendorLeadId);
  }
};

async function getSteps(commit, tenantId, id) {

  try {

    const steps = await HestiaApi.Lead.step.getStepsState(tenantId, id).json();
    commit(Types.SELECT_VENDOR_LEAD, { ...state.currentVendorLead, steps });
  } catch {

    // empty
  }
}

// mutations
const mutations = {
  [Types.RECEIVE_VENDOR_LEADS](state, vendorLeads) {

    state.vendorLeads = vendorLeads;
  },
  [Types.SELECT_VENDOR_LEAD](state, vendorLead) {

    state.currentVendorLead = vendorLead;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
